module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900.42e1fbd.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fontawesome-5.10.2/webfonts/fa-solid-900.eot
// module id = 269
// module chunks = 1